import { render, staticRenderFns } from "./ProductFilterContent.vue?vue&type=template&id=0ddc8368&scoped=true&"
import script from "./ProductFilterContent.vue?vue&type=script&lang=js&"
export * from "./ProductFilterContent.vue?vue&type=script&lang=js&"
import style0 from "./ProductFilterContent.vue?vue&type=style&index=0&id=0ddc8368&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddc8368",
  null
  
)

export default component.exports